import { JSX } from "react";

import InfoIconTooltip from "components/tooltip/InfoIconTooltip";
import { useRootStore } from "store";
import { Loader } from "components/loader/Loader";

import "./SummaryModule.scss";

type Props = {
  moduleTitle: string;
  info?: string | JSX.Element;
  children: JSX.Element;
  hideLoader?: boolean;
};

export default function SummaryModule({
  moduleTitle,
  info,
  children,
  hideLoader
}: Props) {
  const { isLoading } = useRootStore((state) => state.wizard);

  return (
    <section className="summaryModule">
      <div className="moduleHeader">
        <div className="d-flex align-items-center">
          <h2 className="mr-3">{moduleTitle}</h2>
          {isLoading && !hideLoader && <Loader className="mt-2" />}
        </div>
        <div>
          <InfoIconTooltip text={info} />
        </div>
      </div>
      <div className="moduleContent">{children}</div>
    </section>
  );
}
